"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("@/api/store");
var _TableHeadList = require("../creatStore/TableHeadList");
var _default3 = require("../creatStore/default");
var _utils = require("@/utils");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'creatAttr',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    // 商品数据
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 单规格
    OneattrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 多规格
    ManyAttrValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    //批量添加规格
    oneFormBatch: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      formValidate: this.value,
      // 商品数据
      // 分佣类型：1-比例分佣，2-固定金额分佣
      brokerageTypeList: [{
        label: '比例分佣',
        value: 1
      }, {
        label: '固定金额分佣',
        value: 2
      }],
      isAttr: false,
      // 是否需要显示sku
      ruleList: [],
      // 商品属性模板列表
      currentIndex: 0,
      // 当前规格索引
      changeAttrValue: '',
      // 当前要修改的规格值
      canSel: true,
      // 规格图片添加判断
      // 规格数据
      formDynamic: {
        attrsName: '',
        attrsVal: ''
      },
      attrs: [] // 规格列表
    };
  },
  computed: {
    // 单规格表头
    oneAttrTableTitle: function oneAttrTableTitle() {
      var arr = _TableHeadList.GoodsTableHead.slice(0, -2);
      return arr;
    },
    attrValue: function attrValue() {
      var obj = Object.assign({}, _default3.defaultObj.attrValue[0]);
      delete obj.image;
      return obj;
    }
  },
  watch: {
    formValidate: {
      handler: function handler(newVal) {
        this.formValidate = newVal;
        // this.$emit('input', newVal);
      } // deep: true,
    }
  },
  mounted: function mounted() {
    if (this.formValidate.specType) {
      this.productGetRule(); //加载商品规格选项
      // 添加 optionList 字段
      this.createOptionList(this.formValidate.attr);
      // 生成规格属性数据
      this.generateAttr(this.formValidate.attr);
    }
  },
  methods: {
    // 合并单元格
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0 && rowIndex > 0) {
        var lable = column.label;
        //这里判断第几列需要合并
        var tagFamily = this.ManyAttrValue[rowIndex].attrValue[lable];
        var index = this.ManyAttrValue.findIndex(function (item, index) {
          if (index > 0) return item.attrValue[lable] == tagFamily;
        });
        if (rowIndex == index) {
          var len = 1;
          for (var i = index + 1; i < this.ManyAttrValue.length; i++) {
            if (this.ManyAttrValue[i].attrValue[lable] !== tagFamily) {
              break;
            }
            len++;
          }
          return {
            rowspan: len,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 生成列表 行 列 数据
    tableCellClassName: function tableCellClassName(_ref2) {
      var row = _ref2.row,
        column = _ref2.column,
        rowIndex = _ref2.rowIndex,
        columnIndex = _ref2.columnIndex;
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex || '';
      column.index = columnIndex;
    },
    // 获取商品属性模板
    productGetRule: function productGetRule() {
      var _this2 = this;
      (0, _store.templateListApi)(this.tableFrom).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          list[i].ruleValue = JSON.parse(list[i].ruleValue);
        }
        _this2.ruleList = list;
      });
    },
    // 修改佣金是否为默认设置
    onChangetype: function onChangetype(item) {
      var _this3 = this;
      if (item === 1) {
        this.OneattrValue.map(function (item) {
          _this3.$set(item, 'brokerage', null);
        });
        this.ManyAttrValue.map(function (item) {
          _this3.$set(item, 'brokerage', null);
        });
      } else {
        this.OneattrValue.map(function (item) {
          _this3.$set(item, 'brokerage', 0);
        });
        this.ManyAttrValue.map(function (item) {
          _this3.$set(item, 'brokerage', 0);
        });
      }
      // 开启单独设置佣金时，默认分佣类型为比例分佣
      if (item) {
        this.OneattrValue.forEach(function (row) {
          if (!row.brokerageType) _this3.$set(row, 'brokerageType', 1);
        });
        this.ManyAttrValue.forEach(function (row) {
          if (!row.brokerageType) _this3.$set(row, 'brokerageType', 1);
        });
        if (this.oneFormBatch[0] && !this.oneFormBatch[0].brokerageType) {
          this.$set(this.oneFormBatch[0], 'brokerageType', 1);
        }
      }
      this.generateHeader(this.formValidate.attr);
    },
    // 修改规格类型
    onChangeSpec: function onChangeSpec(num) {
      this.isAttr = true;
      if (num) this.productGetRule();
    },
    // 选择规格模板
    confirmAttrTemp: function confirmAttrTemp(name) {
      var _this4 = this;
      this.canSel = true;
      this.formValidate.selectRule = name;
      if (!this.formValidate.selectRule) {
        return this.$message.warning('请选择属性');
      }
      var dataAttrs = [];
      this.ruleList.forEach(function (item) {
        if (item.ruleName === _this4.formValidate.selectRule) {
          item.ruleValue.forEach(function (i) {
            dataAttrs.push({
              attrName: i.value,
              optionList: i.detail.map(function (val) {
                return {
                  value: val,
                  image: '',
                  sort: 0
                };
              }),
              id: 0,
              isShowImage: 0,
              sort: i + 1
            });
          });
        }
        _this4.formValidate.attr = dataAttrs;
      });
      this.generateAttr(this.formValidate.attr);
    },
    // 添加 optionList 字段
    createOptionList: function createOptionList(attr) {
      // 如果 optionList 字段无内容
      if (attr[0].optionList.length == 0) {
        // 添加 optionList 内容
        this.attrs = attr.map(function (item) {
          var attrValueList = item.attrValues.split(',');
          item.optionList = attrValueList.map(function (val) {
            return {
              value: val,
              image: ''
            };
          });
        });
      }
    },
    // 生成商品规格表头
    generateHeader: function generateHeader(attr) {
      var specificationsColumns = attr.map(function (item) {
        return {
          title: item.attrName,
          key: item.attrName,
          minWidth: 200,
          fixed: 'left'
        };
      });
      var arr;
      // 开启佣金设置
      if (this.formValidate.isSub) {
        arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.commissionTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
      } else {
        arr = [].concat(_toConsumableArray(specificationsColumns), _toConsumableArray(_TableHeadList.imageTableHead), _toConsumableArray(_TableHeadList.GoodsTableHead));
      }
      this.$set(this.formValidate, 'header', arr);
      this.tableKey += 1;
    },
    // 生成规格组合
    generateCombinations: function generateCombinations(attr) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (attr.length === 0) {
        return [prefix];
      }
      var _attr = _toArray(attr),
        first = _attr[0],
        rest = _arrayLikeToArray(_attr).slice(1);
      return first.optionList.flatMap(function (detail) {
        return _this5.generateCombinations(rest, [].concat(_toConsumableArray(prefix), [detail.value]));
      });
    },
    // 生成规格属性数据
    generateAttr: function generateAttr(attr, val) {
      var _this6 = this;
      // 生成商品规格表头
      this.generateHeader(attr);
      // 生成规格值组合
      var combinations = this.generateCombinations(attr);
      var rows = combinations.map(function (combination) {
        var row = {
          attrArr: combination,
          attrValueShow: {},
          attrValue: {},
          image: '',
          price: 0,
          cost: 0,
          otPrice: 0,
          stock: 0,
          barCode: '',
          weight: 0,
          volume: 0,
          brokerage: 0,
          brokerageType: 1,
          brokerageRate: 0,
          isShow: true
        };
        for (var i = 0; i < combination.length; i++) {
          var value = combination[i];
          _this6.$set(row, attr[i].attrName, value);
          _this6.$set(row, 'title', attr[i].attrName);
          _this6.$set(row, 'key', attr[i].attrName);
          _this6.$set(row.attrValueShow, attr[i].attrName, value);
          row.attrValue = row.attrValueShow;
          // 如果ManyAttrValue中存在该属性值，则赋值
          for (var k = 0; k < _this6.ManyAttrValue.length; k++) {
            var manyItem = _this6.ManyAttrValue[k];
            // 对比两个数组是否完全相等
            if (k > 0 && manyItem.attrArr.length && (0, _utils.arraysEqual)(manyItem.attrArr, combination)) {
              Object.assign(row, {
                // attrArr: manyItem.attrArr,
                // attrValue: manyItem.attrValue,
                price: manyItem.price || 0,
                cost: manyItem.cost || 0,
                otPrice: manyItem.otPrice || 0,
                stock: manyItem.stock || 0,
                image: manyItem.image || '',
                sku: manyItem.sku || '',
                weight: manyItem.weight || 0,
                isDefault: manyItem.isDefault || 0,
                volume: manyItem.volume || 0,
                barCode: manyItem.barCode || '',
                brokerage: manyItem.brokerage || 0,
                brokerageType: manyItem.brokerageType || 1,
                brokerageRate: manyItem.brokerageRate || 0,
                isShow: manyItem.isShow
              });
            } else if (k > 0 && manyItem.attrArr.length && attr[i].isShowImage && combination.includes(val)) {
              // data[i].detail中的value是规格值 存在与 manyItem.attr_arr 中的某一项
              attr[i].optionList.map(function (e, ii) {
                combination.includes(e.value) && _this6.$set(row, 'image', e.image);
              });
            }
          }
        }
        return row;
      });
      this.$nextTick(function () {
        // rows数组第一项 新增默认数据 oneFormBatch
        _this6.$emit('changeManyAttrValue', [].concat(_toConsumableArray(_this6.oneFormBatch), _toConsumableArray(rows)));
      });
    },
    // 新增规格
    handleAddRole: function handleAddRole() {
      var _this7 = this;
      var data = {
        attrValues: this.formDynamic.attrsName,
        attrValue: [],
        isShowImage: 0,
        optionList: []
      };
      //  let attr = []
      //  attr.push(data);
      // this.$set(this.formValidate, 'attrs',attr)

      this.$nextTick(function () {
        _this7.formValidate.attr.push(data);
        _this7.$emit('changeManyAttrValue', _toConsumableArray(_this7.ManyAttrValue));
        _this7.$emit('input', _this7.formValidate);
      });
    },
    // 另存为模板
    handleSaveAsTemplate: function handleSaveAsTemplate() {
      var _this8 = this;
      this.$prompt('', '请输入模板名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function inputValidator(value) {
          if (value === null) {
            return '输入不能为空';
          }
          if (value.length > 30) return '输入限制30字以内';
        }
      }).then(function (_ref3) {
        var value = _ref3.value;
        var spec = _this8.formValidate.attr.map(function (item) {
          return {
            value: item.attrName,
            detail: item.optionList.map(function (e) {
              return e.value;
            })
          };
        });
        var data = {
          id: 0,
          ruleName: value,
          ruleValue: JSON.stringify(spec)
        };
        (0, _store.attrCreatApi)(data).then(function (res) {
          _this8.$message.success('提交成功');
          _this8.productGetRule();
          _this8.clear();
          _this8.loading = false;
          _this8.loadingBtn = false;
        }).catch(function () {
          _this8.loading = false;
          _this8.loadingBtn = false;
        });
      }).catch(function () {});
    },
    // 规格拖拽排序后
    onMoveSpec: function onMoveSpec(event) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var type = arguments.length > 2 ? arguments[2] : undefined;
      var oldIndex = event.oldIndex,
        newIndex = event.newIndex;
      // if (type == 'value') {
      //   const [movedItem] = this.formValidate.attr[index].attrValue.splice(oldIndex, 1);
      //   this.formValidate.attr[index].attrValue.splice(newIndex, 0, movedItem);
      // }
      this.generateAttr(this.formValidate.attr);
    },
    // 修改当前选中的规格索引
    changeCurrentIndex: function changeCurrentIndex(i) {
      this.currentIndex = i;
    },
    // 聚焦后更新当前要修改的的规格值
    handleFocus: function handleFocus(val) {
      this.changeAttrValue = val;
    },
    // 失去焦点后重置当前要修改的规格值
    handleBlur: function handleBlur() {
      this.changeAttrValue = '';
    },
    // 规格图片添加开关
    addPic: function addPic(e, i) {
      var _this9 = this;
      if (e) {
        this.formValidate.attr.map(function (item, ii) {
          if (ii !== i) {
            _this9.$set(item, 'isShowImage', 0);
          }
        });
        this.canSel = false;
      } else {
        this.canSel = true;
      }
    },
    // 删除属性
    handleRemoveValue: function handleRemoveValue(item, index, val) {
      item.optionList.splice(index, 1);
      this.generateAttr(this.formValidate.attr);
    },
    // 删除表格中的属性
    delAttrTable: function delAttrTable(val) {
      for (var i = 0; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.attrArr && item.attrArr.includes(val)) {
          this.ManyAttrValue.splice(i, 1);
          i--;
        }
      }
    },
    // 在规格中选择规格图片
    handleSelImg: function handleSelImg(item) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        item.image = img[0].sattDir;
        _this.changeSpecImg([item.value], img[0].sattDir);
      }, '1', 'content');
    },
    // 修改规格图片
    changeSpecImg: function changeSpecImg(arr, img) {
      var _this0 = this;
      // 判断是否存在规格图
      var isHas = false;
      for (var i = 1; i < this.ManyAttrValue.length; i++) {
        var item = this.ManyAttrValue[i];
        if (item.image && this.isSubset(item.attrArr, arr)) {
          isHas = true;
          break;
        }
      }
      if (isHas) {
        this.$confirm('可以同步修改下方该规格图片，确定要替换吗？', '提示', {
          confirmButtonText: '替换',
          cancelButtonText: '暂不',
          type: 'warning'
        }).then(function () {
          var _iterator = _createForOfIteratorHelper(_this0.ManyAttrValue),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var val = _step.value;
              if (_this0.isSubset(val.attrArr, arr)) {
                _this0.$set(val, 'image', img);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }).catch(function () {});
      } else {
        var _iterator2 = _createForOfIteratorHelper(this.ManyAttrValue),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var val = _step2.value;
            if (this.isSubset(val.attrArr, arr)) {
              this.$set(val, 'image', img);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    // 检查元素是否存在
    isSubset: function isSubset(arr1, arr2) {
      // 将数组转换为 Set，以便进行高效的包含检查
      var set1 = new Set(arr1);
      var set2 = new Set(arr2);

      // 检查 set2 中的每个元素是否都在 set1 中
      var _iterator3 = _createForOfIteratorHelper(set2),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var elem = _step3.value;
          if (!set1.has(elem)) {
            return false;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return true;
    },
    // 删除规格图片
    handleRemoveImg: function handleRemoveImg(item) {
      item.image = '';
    },
    // 点击添加规格值按钮聚焦输入框
    handleShowPop: function handleShowPop(index) {
      this.$refs['inputRef_' + index][0].focus();
    },
    // 添加属性
    createAttr: function createAttr(value, idx) {
      var _this1 = this;
      if (value) {
        // 判断是否存在同样数据
        var isExist = this.formValidate.attr[idx].optionList.some(function (item) {
          return item.value === value;
        });
        if (isExist) {
          this.$message.error('规格值已存在');
          return;
        }
        this.formValidate.attr[idx].optionList.push({
          value: value,
          image: ''
        });
        if (this.ManyAttrValue.length) {
          this.generateAttr(this.formValidate.attr, value);
          // this.addOneAttr(this.formValidate.attr[idx].attrName, value);
        } else {
          this.generateAttr(this.formValidate.attr);
        }
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
        this.clearAttr();
        setTimeout(function () {
          if (_this1.$refs['popoverRef_' + idx]) {
            //重点是以下两句
            _this1.$refs['popoverRef_' + idx][0].doShow(); //打开的
            //重点是以上两句
          }
        }, 20);
      } else {
        this.$refs['popoverRef_' + idx][0].doClose(); //关闭的
      }
    },
    // 新增一条属性
    addOneAttr: function addOneAttr(val, val2) {
      this.generateAttr(this.formValidate.attr, val2);
    },
    clearAttr: function clearAttr() {
      this.formDynamic.attrsName = '';
      this.formDynamic.attrsVal = '';
    },
    // 删除规格
    handleRemoveAttr: function handleRemoveAttr(index) {
      this.formValidate.attr.splice(index, 1);
      if (!this.formValidate.attr.length) {
        this.formValidate.header = [];
        this.ManyAttrValue = [];
      } else {
        this.generateAttr(this.formValidate.attr);
      }
      this.canSel = true;
    },
    // 修改规格名称
    changeAttr: function changeAttr(index, val) {
      if (val.trim().length && this.formValidate.attr[index].optionList.length) {
        this.generateHeader(this.formValidate.attr);
        if (this.ManyAttrValue.length) {
          this.formValidate.attr[index].attrName = val;
          this.generateAttr(this.formValidate.attr);
          // this.ManyAttrValue.map((item, i) => {
          //   if (i > 0) {
          //     if (Object.keys(item.attrValueShow).includes(this.changeAttrValue)) {
          //       item.attrValueShow[val] = item.attrValueShow[this.changeAttrValue];
          //       item[val] = item[this.changeAttrValue];
          //       delete item.attrValueShow[this.changeAttrValue];
          //       delete item[this.changeAttrValue];
          //     }
          //   }
          // });
          this.changeAttrValue = val;
        }
      } else {
        this.generateAttr(this.formValidate.attr);
      }
      // 触发父组件数据同步
      this.$emit('input', this.formValidate);
    },
    // 规格值改变
    changeValue: function changeValue(val, index, indexn) {
      var _this10 = this;
      if (this.ManyAttrValue.length) {
        var key = this.formValidate.attr[index].attrName;
        this.ManyAttrValue.map(function (item, i) {
          if (i > 0) {
            if (Object.keys(item).includes(key) && item[key] === _this10.changeAttrValue) {
              item[key] = val;
              item.attrValue[key] = val;
              var idx = item.attrArr.findIndex(function (item) {
                return item === _this10.changeAttrValue;
              });
              item.attrArr[idx] = val;
            }
          }
        });
        this.changeAttrValue = val;
      } else {
        this.generateAttr(this.formValidate.attr, 1);
      }
      this.$nextTick(function () {
        _this10.$emit('changeManyAttrValue', _toConsumableArray(_this10.ManyAttrValue));
        _this10.$emit('input', _this10.formValidate);
      });
    },
    keyupEvent: function keyupEvent(key, val, index, num) {
      var re = /([0-9]+.[0-9]{2})[0-9]*/;
      switch (num) {
        case 1:
          this.oneFormBatch[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.oneFormBatch[index], key, String(val).replace(re, '$1'));
          break;
        case 2:
          this.OneattrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.OneattrValue[index], key, String(val).replace(re, '$1'));
          break;
        default:
          this.ManyAttrValue[index][key] = key === 'stock' ? parseInt(val) : this.$set(this.ManyAttrValue[index], key, String(val).replace(re, '$1'));
          break;
      }
    },
    // 返佣输入限制：只能输入 0-100 的数字（最多两位小数）
    limitBrokerage: function limitBrokerage(row, key) {
      var val = String(row[key] == null ? '' : row[key]).replace(/[^\d.]/g, '');
      var parts = val.split('.');
      if (parts.length > 1) {
        val = parts[0] + '.' + parts.slice(1).join('').slice(0, 2);
      }
      if (val !== '' && parseFloat(val) > 100) {
        val = '100';
      }
      this.$set(row, key, val);
    },
    // 固定金额输入限制：非负数字（最多两位小数）
    limitAmount: function limitAmount(row, key) {
      var val = String(row[key] == null ? '' : row[key]).replace(/[^\d.]/g, '');
      var parts = val.split('.');
      if (parts.length > 1) {
        val = parts[0] + '.' + parts.slice(1).join('').slice(0, 2);
      }
      this.$set(row, key, val);
    },
    // 固定金额分佣占售价的百分比（纯前端展示），售价为空或为 0 时不展示
    getBrokeragePercent: function getBrokeragePercent(row) {
      var brokerage = parseFloat(row.brokerage);
      var price = parseFloat(row.price);
      if (isNaN(brokerage) || isNaN(price) || price <= 0) return '';
      return "\u5360\u552E\u4EF7 ".concat((brokerage / price * 100).toFixed(2), "%");
    },
    // 切换分佣类型时清空另一种分佣数据，避免脏数据
    // 用 $set 更新 brokerageType，保证回显新增的字段也是响应式的（否则连续切换无反应）
    changeBrokerageType: function changeBrokerageType(row, val) {
      this.$set(row, 'brokerageType', val);
      if (val === 1) {
        // 比例分佣：清空固定金额
        this.$set(row, 'brokerage', null);
      } else if (val === 2) {
        // 固定金额分佣：清空分佣比例
        this.$set(row, 'brokerageRate', null);
      }
    },
    //返佣输入
    keyupEventBrokerage: function keyupEventBrokerage(val, index, num) {
      switch (num) {
        case 1:
          this.oneFormBatch[index][val] = this.oneFormBatch[index][val] > 0 ? parseInt(this.oneFormBatch[index][val]) : 0;
          break;
        case 2:
          this.OneattrValue[index][val] = this.OneattrValue[index][val] > 0 ? parseInt(this.OneattrValue[index][val]) : 0;
          break;
        default:
          this.ManyAttrValue[index][val] = this.ManyAttrValue[index][val] > 0 ? parseInt(this.ManyAttrValue[index][val]) : 0;
      }
    },
    // 批量添加
    batchAdd: function batchAdd() {
      var _this11 = this;
      var arr = [];
      if (this.isDisabled) return;
      var _iterator4 = _createForOfIteratorHelper(this.formValidate.attr),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var val = _step4.value;
          if (this.oneFormBatch[0][val.attrName]) {
            arr.push(this.oneFormBatch[0][val.attrName]);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.ManyAttrValue.forEach(function (val) {
        if (arr.length && val.attrArr) {
          var attrVal = val.attrArr;
          if (_this11.isSubset(Object.values(attrVal), arr)) {
            _this11.batchData(val);
          }
        } else {
          _this11.batchData(val);
        }
      });
    },
    // 批量数据
    batchData: function batchData(val) {
      if (this.oneFormBatch[0].image) this.$set(val, 'image', this.oneFormBatch[0].image);
      if (this.oneFormBatch[0].price > 0) this.$set(val, 'price', this.oneFormBatch[0].price);
      if (this.oneFormBatch[0].cost > 0) this.$set(val, 'cost', this.oneFormBatch[0].cost);
      if (this.oneFormBatch[0].otPrice > 0) this.$set(val, 'otPrice', this.oneFormBatch[0].otPrice);
      if (this.oneFormBatch[0].barCode) this.$set(val, 'barCode', this.oneFormBatch[0].barCode);
      if (this.oneFormBatch[0].stock >= 0) this.$set(val, 'stock', this.oneFormBatch[0].stock);
      if (this.oneFormBatch[0].weight >= 0) this.$set(val, 'weight', this.oneFormBatch[0].weight);
      if (this.oneFormBatch[0].volume >= 0) this.$set(val, 'volume', this.oneFormBatch[0].volume);
      if (this.oneFormBatch[0].brokerageType) {
        this.$set(val, 'brokerageType', this.oneFormBatch[0].brokerageType);
        // 按分佣类型同步对应的分佣数据，并清空另一种
        if (this.oneFormBatch[0].brokerageType == 1) {
          this.$set(val, 'brokerageRate', this.oneFormBatch[0].brokerageRate);
          this.$set(val, 'brokerage', null);
        } else if (this.oneFormBatch[0].brokerageType == 2) {
          this.$set(val, 'brokerage', this.oneFormBatch[0].brokerage);
          this.$set(val, 'brokerageRate', null);
        }
      }
    },
    // 清空批量规格信息
    batchDel: function batchDel() {
      this.$emit('handleBatchDel');
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (tit === '1' && !num) {
          _this.formValidate.image = img[0].sattDir;
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.formValidate.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.formValidate.sliderImages.push(item.sattDir);
          });
        }
        if (tit === '3' && status === 'video') {
          var videoInfo = img[0];
          if (videoInfo.attType !== 'video/mp4') {
            this.$message.warning('请重新选择视频！');
          } else {
            _this.$set(_this.formValidate, 'videoLink', videoInfo.sattDir);
          }
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 切换默认选中规格
    changeDefaultSelect: function changeDefaultSelect(e, index) {
      var ManyAttrValues = _toConsumableArray(this.ManyAttrValue);
      ManyAttrValues.map(function (item, i) {
        if (i !== index) {
          item.isDefault = false;
        }
      });
      if (e) ManyAttrValues[index].isShow = true;
      this.$emit('changeManyAttrValue', _toConsumableArray(ManyAttrValues));
    },
    // 改变是否显示
    changeDefaultShow: function changeDefaultShow(index) {
      // 如果默认选中开启 则不可隐藏
      if (this.ManyAttrValue[index].isDefault === true) {
        this.ManyAttrValue[index].isShow = true;
        return this.$message.error('默认规格不可隐藏');
      }
      // 至少显示一个规格
      if (!this.ManyAttrValue.some(function (item) {
        return item.isShow;
      })) {
        this.ManyAttrValue[index].isShow = true;
        this.$message.error('至少显示一个规格');
      }
    }
  }
};